/**
 * PostHog consented-identity helper.
 *
 * Rules (aligned with the analytics addendum):
 *   1. NEVER call `posthog.identify()` if iubenda Measurement consent
 *      (purpose 4) is absent — do the check here, not in every caller.
 *   2. Send only the minimum identity required for admin analytics:
 *        - internal user_id
 *        - email
 *        - first_name
 *        - surname
 *   3. Persistent anonymous distinct_id is a PostHog default; we don't
 *      touch it.
 *   4. Idempotent — calling twice with the same user is a no-op.
 */

function hasMeasurementConsent() {
  try {
    const cs = (window._iub && window._iub.cs && window._iub.cs.consent) || null;
    if (!cs) return false;
    const purposes = cs.purposes || cs.categories || {};
    return purposes["4"] === true || purposes[4] === true;
  } catch {
    return false;
  }
}

function posthogReady() {
  return typeof window !== "undefined"
    && window.posthog
    && typeof window.posthog.identify === "function";
}

const _last = { user_id: null };

export function identifyConsentedUser(user) {
  if (!user || !user.id) return false;
  if (!posthogReady()) return false;
  if (!hasMeasurementConsent()) return false;
  if (_last.user_id === user.id) return true; // idempotent
  try {
    window.posthog.identify(String(user.id), {
      email: user.email || undefined,
      first_name: user.first_name || undefined,
      surname: user.surname || user.last_name || undefined,
    });
    _last.user_id = user.id;
    return true;
  } catch {
    return false;
  }
}

export function resetConsentedIdentity() {
  _last.user_id = null;
  try {
    if (posthogReady() && typeof window.posthog.reset === "function") {
      window.posthog.reset();
    }
  } catch {
    /* noop */
  }
}

// If iubenda emits consent AFTER Circle login, re-attempt identify.
if (typeof window !== "undefined") {
  document.addEventListener("iubenda_consent_given", () => {
    try {
      const cached = window.__sdCachedCircleUser;
      if (cached) identifyConsentedUser(cached);
    } catch {
      /* noop */
    }
  });
}
